import React from 'react'
import { getAttrs } from 'utils/index'

import Viewport from 'components/Viewport'
import ComponentRenderer from 'components/ComponentRenderer'

export default (props) => {
  const pageComponents = props.project.page.components.map(pageComponent => ({
    _id: pageComponent._id,
    component: pageComponent.component,
    attrs: getAttrs(pageComponent.attributes, { parseAttributes: true })
  }))

  return (
    <Viewport
      device="desktop"
    >
      {pageComponents.map(pageComponent => (
        <ComponentRenderer
          key={pageComponent._id}
          theme={props.project.theme}
          pageComponent={pageComponent}
        />
      ))}
    </Viewport>
  )
}



// WEBPACK FOOTER //
// ./src/components/ProjectPreview/index.js